import { useDispatch, useSelector } from "react-redux";
import React, { useState, useEffect } from "react";
import { closeGiftsListPopup } from "../../redux/actions";
import { PopupContainer } from "./PopupContainer";
import kitcut from "../../utils/kitcut";
import hyphen from "../../utils/hyphen";
import InfiniteScroll from 'react-infinite-scroll-component';
import { getPoints } from "../../utils/getPoints";

export const GiftsListPopup = () => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const langName = useSelector(state => state.app.currentLangName)
    const giftsList = useSelector(state => state.game.gameWheel.gifts)
    const giftsListPopup = useSelector(state => state.game.giftsListPopup)
    const giftsListPopupName = lang.games3
    const showGifts = useSelector(state => state.game.gameWheel.settings?.showGifts)
    const [bodyWidth, setBodyWidth] = useState(0);

    useEffect(() => {
        setBodyWidth(window.innerWidth);
        const handleResize = (event) => {
            setBodyWidth(event.target.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let heightVar = 350
    if (540 <= bodyWidth && bodyWidth <= 991) {
        heightVar = 480
    }

    if (!Array.isArray(giftsList) || !showGifts || (Array.isArray(giftsList) && giftsList.length === 0)) {
        return (null)
    }
    let heightOfContainer = (giftsList.length < 5) ? null : heightVar;
    let pointName = '';

    if (!giftsListPopup) return (null)
    else return (
        <PopupContainer popup={giftsList} popupName={giftsListPopupName} heading={lang.games5} close={() => dispatch(closeGiftsListPopup())}>
            <InfiniteScroll
                pageStart={0}
                dataLength={giftsList.length}
                height={heightOfContainer}
                style={{
                    "margin": "0px 0px -26px 0px",
                    "paddingRight": "10px"
                }}
            >
                {
                    giftsList.map(function (item) {
                        if (item.type === 'points') {
                            pointName = getPoints(langName, item.points);
                        }
                        const itemName = item.type === 'points' ? ('+' + item.points + ' ' + pointName): item.name;
                        if (typeof item.id === 'undefined') return (null)
                        return (
                            <div className="giftsList__line" key={item.id}>
                                <div className="giftsList__left">
                                    <div className="winnersPopup__circle">
                                        {(item.type === 'gift' && item.image)
                                            ? <img className='giftsList__img' alt='gift' src={item.image} />
                                            : <div className="giftsList__points">{'+' + item.points}</div>
                                        }
                                    </div>
                                </div>
                                <div className="giftsList__center">
                                    <div className="giftsList__name">{hyphen(kitcut(itemName, 50))}</div>
                                </div>
                                <div className="giftsList__right">
                                    <div className="giftsList__quantity">
                                        {typeof item.showQuantity !== 'undefined' && item.showQuantity && typeof item.leftQuantity !== 'undefined' && typeof item.totalQuantity !== 'undefined' &&
                                            item.leftQuantity + "/" + item.totalQuantity
                                        }
                                    </div>
                                </div>
                            </div>)
                    })
                }
            </InfiniteScroll>
        </PopupContainer>
    )
}